import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Domain } from 'src/app/services/domain.service';
import { selectDomain } from 'src/app/store/selectors/auth.selectors';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiConfig, ConfigService } from 'src/app/services/config.service';
import { NavigationService } from 'src/app/services/navigation.service';
@Component({
  selector: 'mvp-contact',
  templateUrl: './contact.page.html',
})
export class ContactPage implements OnInit {

  config: ApiConfig;
  domain$: Observable<Domain>;
  environment = environment;

  teamContactForm: FormGroup;
  teamFormRequestStatus: 'success' | 'error' | null = null;
  teamFormResponseMessage = '';

  domainContactForm: FormGroup;
  domainFormRequestStatus: 'success' | 'error' | null = null;
  domainFormResponseMessage = '';

  latestVisitedResource: object;
  latestVisitedResourceText: string;

  constructor(
    private store: Store,
    private http: HttpClient,
    private configService: ConfigService,
    private navigationService: NavigationService
  ) {
    this.config = configService.apiConfig;
    this.domain$ = this.store.select(selectDomain);
    this.teamContactForm = new FormGroup({
      message: new FormControl('', Validators.required),
    });
    this.domainContactForm = new FormGroup({
      message: new FormControl('', Validators.required),
    });
    this.latestVisitedResource = this.navigationService.getLatestResource();
    this.latestVisitedResourceText =  this.latestVisitedResource ? `\n\n Depuis ${this.latestVisitedResource['type'] === 'article' ? 'l\'article suivant' : 'la question suivante' }: ${this.latestVisitedResource['title']}\n\n` : '';
  }

  ngOnInit() {}

  submitDomainForm() {
    if (this.domainContactForm.valid) {
      let formValue = this.domainContactForm.value;
      this.domain$.subscribe(domain => {
        let payload = {
          domain: domain.label,
          message: `${this.latestVisitedResourceText} ${formValue.message} \n\n`,
          email: domain.contact.email
        };

        this.http.post(`${environment.apiUrl}/contact/mail-domain`, payload)
          .subscribe(
            response => {
              this.domainFormRequestStatus = 'success';
              this.domainFormResponseMessage = 'Votre message a été envoyé avec succès !';
            },
            error => {
              this.domainFormRequestStatus = 'error';
              this.domainFormResponseMessage = `Une erreur est survenue. Veuillez réessayer plus tard. En cas de problème persistant, veuillez contacter votre élu CSE directement sur son adresse email : ${domain.contact.email}`;
            }
          );
      });
    }
  }

  submitTeamForm() {
    if (this.teamContactForm.valid) {
      let formValue = this.teamContactForm.value;
      this.domain$.subscribe(domain => {
        let payload = {
          domain: domain.label,
          message: `${this.latestVisitedResourceText} ${formValue.message} \n\n`
        };
  
        this.http.post(`${environment.apiUrl}/contact/mail-team`, payload)
          .subscribe(
            response => {
              this.teamFormRequestStatus = 'success';
              this.teamFormResponseMessage = 'Votre message a été envoyé avec succès !';
            },
            error => {
              this.teamFormRequestStatus = 'error';
              this.teamFormResponseMessage = 'Une erreur est survenue. Veuillez réessayer plus tard. En cas de problème persistant, veuillez contacter votre élu CSE.';
            }
          );
      });
    }
  }  
}
